export default __webpack_public_path__ + "static/media/logo.d822b59e.png";